import { DelayAction } from "./utilityActions";
import { TestCase, World } from "./testCase";
import { FillSceneGraphic, SceneGroup, TextSceneNode } from "../api/scene";
class LogRoot extends World {
    constructor(testCase) {
        super(testCase);
        this._logTestCase = testCase;
    }
}
export class LogTestCase extends TestCase {
    constructor(parameterData) {
        super(parameterData);
        //Data for model
        this._goalLines = new Array();
        this._loglines = new Array();
        this._lineHeight = 8;
        this._delayMilliseconds = 250;
        //Data for model
        this._goalLines = [...parameterData.lines];
        //View
        this._sceneGroup = new SceneGroup();
        //Background Fill
        let fillSceneGraphic = new FillSceneGraphic(this.canvasWidth, this.canvasHeight, "#073642");
        this._sceneGroup.add(fillSceneGraphic);
        //Lines
        let currentY = 0;
        for (let goalLine of this._goalLines) {
            let textSceneNode = new TextSceneNode(goalLine, "#93a1a1", "6px serif", "left", "top");
            textSceneNode.width = this.canvasWidth;
            textSceneNode.height = this._lineHeight;
            textSceneNode.x = 0;
            textSceneNode.y = currentY;
            currentY += this._lineHeight;
            this._sceneGroup.add(textSceneNode);
        }
    }
    queueLogAction(message) {
        this._loglines.push(message);
        super.queueLogAction(message);
        this._actionQueue.add(new DelayAction(this._delayMilliseconds));
    }
    createSceneNode() {
        return this._sceneGroup;
    }
    get canvasWidth() {
        return 100;
    }
    get canvasHeight() {
        return 100;
    }
    get isSuccess() {
        return this._goalLines.length == this._loglines.length
            && this._goalLines.every((v, i) => v == this._loglines[i]);
    }
    //This is the "world" argument that users code against.
    createRoot() {
        return new LogRoot(this);
    }
    createElement(document) {
        let template = document.createElement("template");
        let html = `<div class="log_container">
      <div>
        <div>
          <input type="text" class="log_value w-full bg-darkBack text-darkFore outline-none">
        </div>
        <div>
          <button class="log_button w-full btn-darkBackHigh">Log</button>
        </div>
        <br/>
      </div>
    </div>`;
        html = html.trim(); // Never return a text node of whitespace as the result
        template.innerHTML = html;
        let xValue = template.content.firstElementChild
            .getElementsByClassName("log_value")[0];
        template.content.firstElementChild
            .getElementsByClassName("log_button")[0]
            .addEventListener("click", () => {
            let deltaX = xValue.value;
            xValue.value = "";
            this.queueLogAction(deltaX);
            this.queueEvaluate();
        });
        return template.content.firstElementChild;
    }
    get styleSheet() {
        return `.log_container {
      width: 100%;
      height: 100%;
      display: flex;
      direction: column;
      align-items: center;
      justify-content: center;
    }

    .log_value {
      border: 2px solid var(--color-base02);
    }`;
    }
}
